import { createAppRequest } from '@/services/request';

const request = createAppRequest();
const PREFIX = '/bff/zy-hr/employee-directory';

export type EmployeeDirectoryDepartment = {
  departmentUuid: string;
  departmentName?: string | null;
};

export type EmployeeDirectorySummary = {
  employeeUuid: string;
  memberUuid: string;
  userId?: string | null;
  userUuid?: string | null;
  name?: string | null;
  mobile?: string | null;
  email?: string | null;
  username?: string | null;
  employeeNo?: string | null;
  memberStatus?: string | null;
  workStatus?: string | null;
  departments: EmployeeDirectoryDepartment[];
  departmentUuid?: string | null;
  departmentName?: string | null;
  departmentUuids?: string[];
  departmentNames?: string[];
  employeeLifecycleStatus?: string | null;
  extensionInitialized: boolean;
  masterDataAvailable: boolean;
  extension?: Record<string, any> | null;
};

export type EmployeeDirectorySearchParams = {
  page?: number;
  pageSize?: number;
  keyword?: string;
  deptIds?: string[];
  memberStatus?: string;
  positionUuid?: string;
  jobLevelUuid?: string;
  employeeLifecycleStatus?: string;
  employeeLifecycleStatuses?: string[];
  managerEmployeeUuid?: string;
  excludeOpenResignation?: boolean;
};

export type EmployeeDirectorySearchResult = {
  list: EmployeeDirectorySummary[];
  total: number;
  page: number;
  pageSize: number;
};

const serializeStringArrayParam = (values?: string[]) =>
  values?.length ? values.join(',') : undefined;

export const searchEmployeeDirectory = (
  params: EmployeeDirectorySearchParams,
) =>
  request<EmployeeDirectorySearchResult>(`${PREFIX}/search`, {
    method: 'GET',
    params: {
      ...params,
      deptIds: serializeStringArrayParam(params.deptIds),
      employeeLifecycleStatuses: serializeStringArrayParam(
        params.employeeLifecycleStatuses,
      ),
    },
  });

export const batchGetEmployeeDirectory = (employeeUuids: string[]) =>
  request<EmployeeDirectorySummary[]>(`${PREFIX}/batch`, {
    method: 'POST',
    data: { employeeUuids },
  });

export const batchGetMemberDirectory = (memberUuids: string[]) =>
  request<EmployeeDirectorySummary[]>(`${PREFIX}/batch`, {
    method: 'POST',
    data: { memberUuids },
  });
